import { useAnimation } from "motion/react";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { motion } from "motion/react";
import { useQuery } from "react-query";
import { BASEURL } from "../../../../utils/BaseUrl";
import axios from "axios";
import useGetData from "../../../../hooks/apihooks/useGetData";

const AboutClientText = () => {
  const { ref, inView, entry } = useInView({});
  const animation = useAnimation();
  useEffect(() => {
    if (inView) {
      animation.start({
        y: 0,
        opacity: 1,
        transition: {
          duration: 0.5,
          ease: "easeInOut",
        },
      });
    }
    if (!inView) {
      animation.start({
        y: "50%",
        opacity: 0.5,

        transition: {
          duration: 0.5,
          ease: "easeInOut",
        },
      });
    }
  }, [inView]);

  const { data, isLoading, isError } = useGetData(
    "about-client",
    "getallclient"
  );
  return (
    <div className="flex justify-center flex-col py-10  mx-auto max-w-2xl ">
      <motion.h2
        ref={ref}
        animate={animation}
        className="text-center font-bold lg:text-6xl md:text-2xl sm:text-2xl max-sm:text-2xl my-4 text-g-black"
      >
        {data?.heading}
      </motion.h2>
      <motion.p
        ref={ref}
        animate={animation}
        className="text-center my-4 lg:text-xl md:text-lg sm:text-md max-sm:text-md text-mute-grey"
      >
        {data?.description}
      </motion.p>
    </div>
  );
};

export default AboutClientText;
